import React from "react"
import { Control, FieldValues } from "react-hook-form"
import TextField from "./TextField"

type Props<T extends FieldValues> = {
  name: string;
  control: Control<T, object>;
  label?: string;
  placeholder?: string;
  helperText?: string;
  variant?: "outline" | "flushed"
  labelWidth?: string | number
}

const PasswordField = <T extends FieldValues, >({
  name, control, label, placeholder, helperText, variant, labelWidth,
}: Props<T>) => (
  <TextField
    name={name}
    control={control}
    label={label}
    placeholder={placeholder}
    type="password"
    autoComplete="current-password"
    helperText={helperText}
    variant={variant}
    labelWidth={labelWidth}
  />
  )

export default PasswordField
